import { render, staticRenderFns } from "./CFtGoodsAutocomplete.vue?vue&type=template&id=4dead01c"
import script from "./CFtGoodsAutocomplete.vue?vue&type=script&lang=ts"
export * from "./CFtGoodsAutocomplete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
